module.exports = __webpack_public_path__ + "img/liveOne.2602c467.png";